import { render, staticRenderFns } from "./maintainanceStandardManageList.vue?vue&type=template&id=1488bdb8&scoped=true"
import script from "./maintainanceStandardManageList.vue?vue&type=script&lang=js"
export * from "./maintainanceStandardManageList.vue?vue&type=script&lang=js"
import style0 from "./maintainanceStandardManageList.vue?vue&type=style&index=0&id=1488bdb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1488bdb8",
  null
  
)

export default component.exports